<script>
    import { Doc } from "sveltefire";

    import Loading from '../components/Loading.svelte';
    import LocationCard from '../components/LocationCard.svelte';
    import Fallback from '../components/Fallback.svelte';
    import { getUrlParam } from '../utils';

    const l = getUrlParam('l');
</script>

<Doc path={`locations/${l}`} let:data={location} let:ref={locationRef}>

    <div class="wrapper">
        <LocationCard 
            id={locationRef.id}
            title={location.title}
            showTitle={location.showTitle}
            description={location.description}
            showDescription={location.showDescription}
            directLink={location.directLink}
            lat={location.lat}
            lng={location.lng}
            mapVisible={location.mapVisible}
            location={location}
        />
    </div>

    <div slot="loading">
        <Loading />
    </div>

    <div slot="fallback">
        <Fallback />
    </div>
</Doc>

<style>
    .wrapper {
        margin: -20px 0px;
    }
</style>
